// Common error-code surface consumed by `@airange/shared/i18n-error-code-common`.
//
// Mirrors the `common.*` paths the shared error helpers resolve, but composes
// them from the owned error-code namespaces instead of the monolithic `common`
// catalog, so importing shared error helpers never pulls business dictionaries
// into an app bundle.
import { commonErrorApiCodeReasonAuthShared } from "./errors-api-code-reason-auth-shared";
import { commonErrorApiCodeUnaffiliated } from "./errors-api-code-unaffiliated";
import { commonMessages } from "./common-messages";
import { commonErrors } from "./errors";

export const errorCodeCommon = {
  common: {
    messages: {
      requestFailed: commonMessages.requestFailed,
    },
    errors: {
      ...commonErrors,
      apiCodes: {
        ...commonErrorApiCodeUnaffiliated,
      },
      apiCodeReasons: {
        authShared: commonErrorApiCodeReasonAuthShared,
      },
    },
  },
} as const;
